module.exports = __webpack_public_path__ + "img/nomad5.57836269.jpg";